import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-id", "onClick"]
const _hoisted_2 = { class: "carousel-card__inner" }
const _hoisted_3 = { class: "carousel-card__image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "carousel-card__content" }
const _hoisted_6 = { class: "carousel-card__content-title" }
const _hoisted_7 = { class: "carousel-card__content-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_VueSwiper = _resolveComponent("VueSwiper")!

  return (_ctx.hasProperties)
    ? (_openBlock(), _createBlock(_component_VueSwiper, {
        key: 0,
        ref: "vueSwiper",
        options: _ctx.swiperOptions,
        class: "portfolio-carousel",
        navigation: true,
        "space-between": 30,
        "watch-overflow": true,
        "allow-touch-move": false,
        autoplay: { delay: 5000 },
        breakpoints: {
      320: { slidesPerView: 2 },
      640: { slidesPerView: 3 },
      980: { slidesPerView: 4 },
    },
        style: {"width":"70%"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolios, (portfolio) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: portfolio.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["carousel-card", {'active': portfolio.id === _ctx.modelValue}]),
                  "data-id": portfolio.id,
                  onClick: ($event: any) => (_ctx.selectPortfolio(portfolio.id))
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        src: portfolio.image
                      }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(portfolio.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(portfolio.properties.length) + " " + _toDisplayString(portfolio.properties.length === 1 ? 'Property' : 'Properties'), 1)
                    ])
                  ])
                ], 10, _hoisted_1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1)),
          _createElementVNode("div", {
            class: "swiper-button-prev",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prev()))
          }),
          _createElementVNode("div", {
            class: "swiper-button-next",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next()))
          })
        ]),
        _: 1
      }, 8, ["options"]))
    : _createCommentVNode("", true)
}